const STORAGE_KEY = import.meta.env.DEV
  ? "fiinder_dev_widget_state"
  : "fiinder_widget_state";
const TTL_MS = 30_000;

export type WidgetPersistedState = {
  isVisible: boolean;
  isFullScreen: boolean;
  mode: "chat" | "search";
  searchInput: string;
  roomId?: string;
  scrollPosition?: number;
  searchScrollPosition?: number;
  savedAt: number;
};

export function saveWidgetState(
  state: Omit<WidgetPersistedState, "savedAt">
): void {
  try {
    const persistedState: WidgetPersistedState = {
      ...state,
      savedAt: Date.now(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(persistedState));
  } catch {
    // Silently fail if quota exceeded or sessionStorage unavailable
  }
}

export function getWidgetState(): WidgetPersistedState | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return null;

    const parsed = JSON.parse(stored);

    // Validate types
    if (
      !parsed ||
      typeof parsed.isVisible !== "boolean" ||
      typeof parsed.isFullScreen !== "boolean" ||
      typeof parsed.mode !== "string" ||
      (parsed.mode !== "chat" && parsed.mode !== "search") ||
      typeof parsed.searchInput !== "string" ||
      typeof parsed.savedAt !== "number" ||
      (parsed.roomId !== undefined && typeof parsed.roomId !== "string") ||
      (parsed.scrollPosition !== undefined && (typeof parsed.scrollPosition !== "number" || parsed.scrollPosition < 0)) ||
      (parsed.searchScrollPosition !== undefined && (typeof parsed.searchScrollPosition !== "number" || parsed.searchScrollPosition < 0))
    ) {
      return null;
    }

    // Check TTL
    if (Date.now() - parsed.savedAt > TTL_MS) {
      return null;
    }

    return parsed as WidgetPersistedState;
  } catch {
    return null;
  }
}

export function clearWidgetState(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Silently fail
  }
}
